import { apiClient } from './apiClient';
import { ListPaginationFilter } from './accessControlApi';

export type TeamManagement = {
  id: string;
  name: string;
  description: string;
  isActive: boolean;
  memberCount: number;
  leaderUserId?: string | null;
  leaderName?: string | null;
  bossNames?: string[];
  createdAt: string;
  updatedAt: string;
};

export type TeamListResult = {
  items: TeamManagement[];
  totalCount: number;
  page: number;
  pageSize: number;
};

export type AccessControlTeamMember = {
  id: string;
  teamId: string;
  userId: string;
  userName: string;
  userEmail: string;
  isLeader: boolean;
  bossUserId?: string | null;
  bossUserName?: string | null;
  createdAt: string;
};

export async function listTeams(filter: ListPaginationFilter = {}): Promise<TeamListResult> {
  const response = await apiClient.get<TeamListResult>('/v1/access-control/teams', { params: filter });
  return response.data;
}

export async function createTeam(payload: {
  name: string;
  description?: string;
  isActive: boolean;
}): Promise<TeamManagement> {
  const response = await apiClient.post<TeamManagement>('/v1/access-control/teams', payload);
  return response.data;
}

export async function updateTeam(
  id: string,
  payload: { name: string; description?: string; isActive: boolean },
): Promise<TeamManagement> {
  const response = await apiClient.put<TeamManagement>(`/v1/access-control/teams/${id}`, payload);
  return response.data;
}

export async function deleteTeam(id: string): Promise<void> {
  await apiClient.delete(`/v1/access-control/teams/${id}`);
}

export async function listTeamMembers(teamId: string): Promise<AccessControlTeamMember[]> {
  const response = await apiClient.get<AccessControlTeamMember[]>(`/v1/access-control/teams/${teamId}/members`);
  return response.data;
}

export async function addTeamMember(
  teamId: string,
  payload: { userId: string; isLeader: boolean; bossUserId?: string | null },
): Promise<AccessControlTeamMember> {
  const response = await apiClient.post<AccessControlTeamMember>(
    `/v1/access-control/teams/${teamId}/members`,
    payload,
  );
  return response.data;
}

export async function updateTeamMember(
  teamId: string,
  userId: string,
  payload: { userId: string; isLeader: boolean; bossUserId?: string | null },
): Promise<AccessControlTeamMember> {
  const response = await apiClient.put<AccessControlTeamMember>(
    `/v1/access-control/teams/${teamId}/members/${userId}`,
    payload,
  );
  return response.data;
}

export async function removeTeamMember(teamId: string, userId: string): Promise<void> {
  await apiClient.delete(`/v1/access-control/teams/${teamId}/members/${userId}`);
}
